import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import RSeguimientoServicio from '../modals/modalRSeguimientoServicio';
import FormOrdenesCompras from '../formsSolicitudes/formOrdenesCompras';
import axios from '../../utils/axiosConfig';
import Swal from 'sweetalert2';
import ReporteServicio from "../../Modulos/Reporteservicio";


const MenuContratos = (props) => {
    const { data } = props;
    const menuRef = useRef(null);
    const toggleButtonRef = useRef(null);
    const location = useLocation();
    const { pathname } = location;
    const [fklokSolicitud, setFklokSolicitud] = useState(null);

    const [showModalCompras, setShowModalCompras] = useState(false);

    const [bitOpens, setBitOpens] = useState(false);
    const [bitCreates, setBitCreates] = useState(false);
    const [bitEdits, setBitEdits] = useState(false);
    const [bitDeletes, setBitDeletes] = useState(false);


    // Si la ruta incluye '/historico', no mostramos las opciones extra.
    const mostrarOpcionesExtra = !(pathname.includes('/historico') || pathname.includes('/controlContracts'));


    // Ejemplo: cambiar label según la ruta.
    const serviceTrackingLabel = pathname.includes('/historico') || pathname.includes('/controlContracts')
        ? 'Trazabilidad de servicio'
        : 'Tracking Tiempo Real';

    const serviceLiveLabel = pathname.includes('/historico') || pathname.includes('/controlContracts')
        ? 'Backup streaming'
        : 'En vivo';

    const isModalEnabled = pathname.includes('/historico') || pathname.includes('/trafico');


    // Estados para cada dropdown
    const [dropdownOpenReportes, setDropdownOpenReportes] = useState(false);
    const [dropdownOpenMultimedia, setDropdownOpenMultimedia] = useState(false);
    const [dropdownOpenValitronics, setDropdownOpenValitronics] = useState(false);
    const [dropdownOpenOpciones, setDropdownOpenOpciones] = useState(false);

    const resetInnerDropdowns = () => {
        setDropdownOpenReportes(false);
        setDropdownOpenMultimedia(false);
        setDropdownOpenValitronics(false);
        setDropdownOpenOpciones(false);
    };

    const hideMenuByButton = (button, withFocus = false) => {
        if (!button) return;
        if (withFocus) button.focus();
        const dropdownApi = window?.bootstrap?.Dropdown;
        if (dropdownApi?.getOrCreateInstance) {
            const instance = dropdownApi.getOrCreateInstance(button);
            instance?.hide();
            return;
        }
        const parent = button.closest(".dropdown");
        const menu = parent?.querySelector(".dropdown-menu");
        parent?.classList?.remove("show");
        menu?.classList?.remove("show");
        button.setAttribute("aria-expanded", "false");
    };

    const closeOtherContractMenus = () => {
        const allToggles = document.querySelectorAll(".menu-contratos-toggle");
        allToggles.forEach((btn) => {
            if (btn === toggleButtonRef.current) return;
            hideMenuByButton(btn, false);
        });
    };

    // const abrirReporteEnNuevaVentana = (contrato) => {
    //     // Guardamos el contrato en localStorage
    //     localStorage.setItem("reporte:contrato:data", JSON.stringify(contrato));
    //     localStorage.setItem("reporte:contrato:id", contrato.ContractID);

    //     // Abrimos la ruta de tu app en nueva pestaña
    //     const url = `${window.location.origin}/reportelink/${contrato.ContractID}`;
    //     window.open(url, "_blank");
    // };

    // utils/abrirReporteEnAboutBlank.js

    // Esta función abre una ventana about:blank
    // y dibuja ahí el contenido del reporte con estilos, sin usar rutas.
    function abrirReporteEnAboutBlank(contrato) {
        if (!contrato) {
            alert("No hay datos del contrato");
            return;
        }

        // Props mínimas que tu componente ReporteServicio espera
        const ultPunto = null;
        const contractR = -1;
        const noop = () => { };

        // 1. Renderizamos ReporteServicio a HTML estático (no React vivo)
        const reporteHTML = ReactDOMServer.renderToString(
            <div id="reporte-wrapper" style={{ fontSize: "12px" }}>
                <ReporteServicio
                    contrato={contrato}
                    ultPunto={ultPunto}
                    contractR={contractR}
                    setContainerRef={noop}
                    onReady={noop}
                    printMode
                />
            </div>
        );

        // 2. Abrimos la nueva ventana
        const win = window.open("", "_blank", "noopener,noreferrer");
        if (!win) {
            alert("El navegador bloqueó la ventana emergente");
            return;
        }

        // 3. Estilos.
        // IMPORTANTE:
        // - Tenés que asegurarte que estas rutas existan de verdad en producción.
        // - reporteservicio.css tiene que estar accesible públicamente.
        //   Ej: si la copiaste a public/Pages/Css/reporteservicio.css vas con /Pages/Css/reporteservicio.css
        //
        // También podés agregar Bootstrap o los CSS base del dashboard si tu markup los usa.
        const cssLinks = `
        <link rel="stylesheet" href="/assets/vendor/css/core.css" />
        <link rel="stylesheet" href="/assets/vendor/css/theme-default.css" />
        <link rel="stylesheet" href="/assets/css/demo.css" />
        <link rel="stylesheet" href="/assets/vendor/libs/perfect-scrollbar/perfect-scrollbar.css" />
        <link rel="stylesheet" href="/Pages/Css/reporteservicio.css" />
    `;

        // 4. CSS inline adicional para impresión / layout blanco
        //    Esto es básicamente lo que ya definiste en handlePrint.
        const customStyles = `
                body {
                    background: #fff;
                    margin: 0;
                    padding: 20px;
                    font-family: Arial, sans-serif;
                    color: #000;
                }

                .titleLabel{        
                    font-size: 16px;
                }

                .informacionContratoReporte{
                    font-size:12px;
                }

                .informacionContratoReporte .maps{
                    margin-top: 50px;
                }

                .informacionContratoReporte .row{
                    display:flex;
                    flex-wrap:wrap;
                    margin-bottom:10px;
                }

                .informacionContratoReporte .col{
                    flex:1;
                    min-width:150px;
                    padding:5px;
                }

                .informacionContratoReporte .col img{
                    width:100%;
                    height:auto;
                }

                .cuadrophotos{
                    display:grid;
                    grid-template-columns:repeat(3,1fr);
                    gap:10px;
                    margin-left:5px;
                    margin-top:20px;
                }

                .cardphoto{
                    background-color:#a0b5bf;
                    padding:0;
                    margin:0;
                    width:100%;
                    box-sizing:border-box;
                }

                .cardphoto img{
                    width:100%;
                    height:200px;
                    object-fit:cover;
                }

                .cardphoto .card-text{
                    font-size:10px;
                    color:#000;
                }

                .cardphoto .card-body{
                    padding:0.5rem;
                }

                .comparision{
                    display:flex;
                    flex-direction:column;
                    page-break-before:always;
                }

                .comparision h3{
                    margin-bottom:40px;
                }

                .infoAditionalBody{
                    height:auto;
                }

                .infoAditionalBody p{
                    margin-bottom:0;
                    font-size:10px;
                }

                .comparision .comparisionImgs{
                    display:flex;
                    flex-direction:row;
                    justify-content:space-evenly;
                    margin-top:12px;
                }

                .comparisionResults{
                    margin-top:40px;
                    margin-bottom:30px;
                    font-size:12px;
                }

                .cardphotoComparative{
                    position:relative;
                    display:inline-block;
                    width:calc(46% - 10px);
                    margin-bottom:20px;
                }

                .cardphotoComparative img{
                    display:block;
                    width:100%;
                    height:200px;
                    border-radius:8px;
                }

                .cardphotoComparative.border-green::before,
                .cardphotoComparative.border-green::after{
                    border-color:green;
                }

                .cardphotoComparative.border-yellow::before,
                .cardphotoComparative.border-yellow::after{
                    border-color:yellow;
                }

                .cardphotoComparative.border-red::before,
                .cardphotoComparative.border-red::after{
                    border-color:red;
                }

                .cardphotoComparative::before,
                .cardphotoComparative::after{
                    content:'';
                    position:absolute;
                    top:1px;
                    left:1px;
                    right:1px;
                    bottom:1px;
                    border:2px solid;
                    border-radius:8px;
                    opacity:0;
                    animation:pulse 2s infinite;
                }

                .cardphotoComparative::before{
                    animation-delay:0s;
                }
                .cardphotoComparative::after{
                    animation-delay:1s;
                }

                .tablePadre{
                    border-collapse:collapse;
                    page-break-before:always;
                }

                .tablePadre th,
                .tablePadre td{
                    border:1px solid #000;
                    padding:2px;
                    font-size:10px;
                }

                @media print {
                    @page {
                        size:A4 portrait;
                        margin:15mm;
                    }
                    body{
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                        background:#fff !important;
                        color:#000 !important;
                    }
                }
            `;

        // 5. Armamos el documento completo que va en la ventana nueva
        const contratoIdForTitle = contrato.ContractID || contrato.id || contrato._id || "";

        const fullHTML = `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="utf-8" />
            <title>Reporte de Servicio ${contratoIdForTitle}</title>
            ${cssLinks}
            <style>${customStyles}</style>
        </head>
        <body>
            ${reporteHTML}

            <script>
                // Esperar a que terminen de cargar imágenes antes de imprimir (opcional)
                function waitForImages(done){
                    const imgs = Array.from(document.querySelectorAll("img"));
                    if (!imgs.length) { done(); return; }
                    let pending = imgs.length;
                    const check = () => {
                        pending--;
                        if (pending <= 0) done();
                    };
                    imgs.forEach(img => {
                        if (img.complete && img.naturalWidth !== 0 && img.naturalHeight !== 0) {
                            check();
                        } else {
                            img.addEventListener("load", check, { once:true });
                            img.addEventListener("error", check, { once:true });
                        }
                    });
                }

                window.addEventListener("load", function() {
                    waitForImages(function() {
                        // si querés imprimir automáticamente, descomenta:
                        // window.print();
                    });
                });
            </script>
        </body>
        </html>`;

        // 6. Escribimos el HTML en la ventana about:blank
        win.document.open();
        win.document.write(fullHTML);
        win.document.close();
    }



    const HandlePageByRole = async () => {
        let data = {
            pagina: "22",
        };

        try {
            const res = await axios.post(
                process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
                JSON.stringify(data),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true, // this should be inside the options object
                }
            );

            // Handle the response here after the request completes
            if (res.data.success === false) {
                window.location = "/";
            } else {
                // console.log("BIt permisos: ", res.data.data);
                if (res.data.data.length > 0) {
                    console.log("Bit permisos obtenidos ordenes: ", res.data.data[0]);
                    setBitOpens(res.data.data[0].bitOpen);
                    setBitCreates(res.data.data[0].bitInsert);
                    setBitEdits(res.data.data[0].bitEdit);
                    setBitDeletes(res.data.data[0].bitDelete);

                    if (res.data.data[0].bitOpen) {
                        console.warn("Tienes todos los permisos");
                        return;
                    } else {
                        Swal.fire({
                            title: 'Información',
                            text: 'No tiene los permisos necesarios para acceder a esta página',
                            icon: 'info',
                            timer: 3000, // The time in milliseconds before the alert closes (3 seconds in this case)
                            showConfirmButton: false,
                            allowOutsideClick: false, // Prevents clicking outside the modal to close it
                            didOpen: () => {
                                Swal.showLoading(); // Shows the loading spinner
                            }
                        }).then(() => {
                            // This will execute after the modal finishes showing
                            console.log("No tiene los permisos necesarios");
                            // window.location.href = "/trafico"; // Redirect to another page
                        });
                    }
                }
            }
        } catch (error) {
            console.error("Error al listar bit permisos:", error);
        }
    };

    const ordenesCompra = () => {
        //abrir modal compras
        HandlePageByRole();
        setShowModalCompras(true);
    };

    // Funciones para alternar cada dropdown
    const toggleDropdownReportes = (e) => {
        e.stopPropagation();
        setDropdownOpenReportes(!dropdownOpenReportes);
    };

    const toggleDropdownMultimedia = (e) => {
        e.stopPropagation();
        setDropdownOpenMultimedia(!dropdownOpenMultimedia);
    };

    const toggleDropdownValitronics = (e) => {
        e.stopPropagation();
        setDropdownOpenValitronics(!dropdownOpenValitronics);
    };

    const toggleDropdownOpciones = (e) => {
        e.stopPropagation();
        setDropdownOpenOpciones(!dropdownOpenOpciones);
    };

    const onCloseModalOrdenesCompra = () => {
        setShowModalCompras(false);
    };

    useEffect(() => {
        // console.log("Ruta actual:", pathname);
        // console.log("Data recibida en MenuContratos:", data);
        // Cerrar todos los dropdowns al hacer clic fuera
        if (props.data && props.data.FKLokSolicitud) {
            // console.log("data menu contratos", props.data.FKLokSolicitud);
            setFklokSolicitud(props.data.FKLokSolicitud);
        }
    }, [props.data]);

    useEffect(() => {
        const handleOutsideMouseDown = (event) => {
            if (!menuRef.current) return;
            if (menuRef.current.contains(event.target)) return;
            // In mobile/responsive, forcing focus on close causes scroll jumps
            // to the previously opened contract card.
            hideMenuByButton(toggleButtonRef.current, false);
            resetInnerDropdowns();
        };

        const root = menuRef.current;
        const handleHidden = () => resetInnerDropdowns();

        root?.addEventListener("hidden.bs.dropdown", handleHidden);
        document.addEventListener("mousedown", handleOutsideMouseDown, true);
        return () => {
            root?.removeEventListener("hidden.bs.dropdown", handleHidden);
            document.removeEventListener("mousedown", handleOutsideMouseDown, true);
        };
    }, []);

    return (
        <>
            <div className="dropdown position-static" ref={menuRef}>
                <button
                    ref={toggleButtonRef}
                    type="button"
                    className="btn p-0 dropdown-toggle hide-arrow menu-contratos-toggle"
                    data-bs-toggle="dropdown"
                    onPointerDown={(event) => event.stopPropagation()}
                    onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        closeOtherContractMenus();
                    }}
                >
                    <i className="bx bx-dots-vertical position-static"></i>
                </button>
                <div className="dropdown-menu">
                    {data.FKLokTipoEquipo !== 8 && (
                        <span
                            onClick={() => props.abrirModal2(data)}
                            className="dropdown-item"
                            style={{ width: '100%' }}
                        >
                            <i className="bx bxs-map me-1"></i> {serviceTrackingLabel}
                        </span>
                    )}
                    {/* {data.FKLokTipoEquipo !== 8 && props.abrirModalEnVivo && (
                        <span
                            onClick={() => props.abrirModalEnVivo(data)}
                            className="dropdown-item en-vivo-menu-item"
                            style={{ width: '100%' }}
                        >
                            <span className="en-vivo-live-dot" aria-hidden="true"></span>
                            <span className="en-vivo-menu-label">{serviceLiveLabel}</span>
                        </span>
                    )} */}
                    <span
                        onClick={() => props.showModalOpenResporteServicio(data)}
                        className="dropdown-item"
                        style={{ width: '100%' }}
                    >
                        <i className="bx bx-file me-1"></i> Monitoreo de tráfico
                    </span>
                    <span className="dropdown">
                        <button onClick={toggleDropdownReportes} className="dropdown-item dropdown-toggle-row">
                            <span><i className="bx bxs-report"></i> Reportes</span>
                            <i className="bx bx-caret-down dropdown-item-chevron"></i>
                        </button>
                        {dropdownOpenReportes && (
                            <div className="containerSpaceMenu">
                                <span
                                    onClick={() => { props.OpenReporteServicio(data); }}
                                    {...(isModalEnabled && {
                                        'data-bs-toggle': 'modal',
                                        'data-bs-target': mostrarOpcionesExtra ? "#ModalReporteServicio" : "#ModalReporteServicioHistorico"
                                    })}
                                    className="dropdown-item"
                                    style={{ width: '100%' }}
                                >
                                    <i className="bx bx-file me-1"></i> Reporte Consolidado
                                </span>

                                {data.FKLokTipoEquipo !== 8 && (
                                    <span
                                        onClick={() => props.abrirModal(data)}
                                        data-bs-toggle="modal"
                                        data-bs-target="#ModalReporteDian"
                                        className="dropdown-item"
                                        style={{ width: '100%' }}
                                    >
                                        <i className="bx bx-file me-1"></i> Reporte Dian
                                    </span>
                                )}
                            </div>
                        )}
                    </span>

                    {/* <span className="dropdown">
                        <button onClick={toggleDropdownMultimedia} className="dropbtn dropdown-item dropdown-toggle-row">
                            <span><i className="bx bx-film"></i> Multimedia</span>
                            <i className="bx bx-caret-down dropdown-item-chevron"></i>
                        </button>
                        {dropdownOpenMultimedia && (
                            <div className="containerSpaceMenu">
                                <span
                                    onClick={() => props.OpenGalleryPhoto(data)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#ModalGaleria"
                                    className="dropdown-item"
                                    style={{ width: '100%' }}
                                >
                                    <i className="bx bx-camera me-1"></i> Imagenes / IA
                                </span>
                                <span
                                    onClick={() => props.OpenGalleryVideo(data)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#ModalVideoGaleria"
                                    className="dropdown-item"
                                    style={{ width: '100%' }}
                                >
                                    <i className="bx bx-video me-1"></i> Videos / IA
                                </span>
                                <span onClick={() => props.OpenUploadPhoto(data)} className="dropdown-item" style={{ width: '100%' }}>
                                    <i className="bx bx-upload me-1"></i> Subir Fotos
                                </span>
                                <span onClick={() => props.OpenUploadVideo(data)} className="dropdown-item" style={{ width: '100%' }}>
                                    <i className="bx bx-upload me-1"></i> Subir Videos
                                </span>

                            </div>
                        )}
                    </span> */}
                    {props.OpenMultimediaHub && (
                        <span onClick={() => props.OpenMultimediaHub(data)} className="dropdown-item" style={{ width: '100%' }}>
                            <i className="bx bx-grid-alt me-1"></i> Centro Multimedia + Streaming
                        </span>
                    )}

                    <span className="dropdown">
                        <button onClick={toggleDropdownValitronics} className="dropdown-item dropdown-toggle-row">
                            <span><i className="bx bx-check-circle"></i> Valitronics</span>
                            <i className="bx bx-caret-down dropdown-item-chevron"></i>
                        </button>
                        {dropdownOpenValitronics && (
                            <div className="containerSpaceMenu">
                                <span
                                    onClick={() => props.OpenComprobante(data)}
                                    // data-bs-toggle="modal"
                                    // data-bs-target="#ModalComprobanteValitronics"
                                    className="dropdown-item"
                                    style={{ width: '100%' }}
                                >
                                    <i className="bx bx-file me-1"></i> Historial de validaciones
                                </span>
                                <span
                                    onClick={() => props.OpenListCheck(data)}
                                    // data-bs-toggle="modal"
                                    // data-bs-target="#ModalListaCheck"
                                    className="dropdown-item"
                                    style={{ width: '100%' }}
                                >
                                    <i className="bx bx-file me-1"></i> Check List Contenedor
                                </span>
                            </div>
                        )}
                    </span>

                    <span className="dropdown">
                        <button onClick={toggleDropdownOpciones} className="dropdown-item dropdown-toggle-row">
                            <span><i className="bx bxs-cog"></i> Opciones</span>
                            <i className="bx bx-caret-down dropdown-item-chevron"></i>
                        </button>
                        {dropdownOpenOpciones && (
                            <div className="containerSpaceMenu">
                                <span
                                    onClick={() => props.showEditContract(data)}
                                    className="dropdown-item"
                                    style={{ width: '100%' }}
                                >
                                    <i className="bx bx-edit-alt me-1"></i> Editar Contrato
                                </span>
                                {mostrarOpcionesExtra && (
                                    <>
                                        <span
                                            onClick={() => props.EditContrato(data)}
                                            className="dropdown-item"
                                            style={{ width: '100%' }}
                                        >
                                            <i className="bx bx-edit-alt me-1"></i> Editar Trayecto
                                        </span>
                                        {data.FKLokTipoEquipo !== 8 && (
                                            <span
                                                onClick={() => props.ActualizarContratoDevice(data)}
                                                className="dropdown-item"
                                                style={{ width: '100%' }}
                                            >
                                                <i className="bx bx-file me-1"></i> Actualizar contrato
                                            </span>
                                        )}
                                    </>
                                )}
                                <span
                                    onClick={() => ordenesCompra()}
                                    className="dropdown-item"
                                    style={{ width: '100%' }}
                                >
                                    <i class='bx bx-task me-1'></i> Ordenes de compras
                                </span>
                            </div>
                        )}
                    </span>
                    {data.FKLokTipoEquipo !== 8 && (
                        <span
                            onClick={() => props.abrirModal(data)}
                            data-bs-toggle="modal"
                            data-bs-target="#ModalDocumentosDian"
                            className="dropdown-item"
                            style={{ width: '100%' }}
                        >
                            <i className="bx bx-folder-open me-1"></i> Documentos DIAN
                        </span>
                    )}
                </div>
            </div>

            {bitOpens && (
                <RSeguimientoServicio
                    isOpen={showModalCompras}
                    title={'Ordenes de compra'}
                    onClose={onCloseModalOrdenesCompra}
                    childComponent={<FormOrdenesCompras fklokSolicitud={fklokSolicitud} bitCreates={bitCreates} bitEdits={bitEdits} bitDeletes={bitDeletes} bitOpens={bitOpens} />}
                />
            )}

        </>
    );
};

export default MenuContratos;
